import React from 'react';
import { Card, CardContent, Grid, Skeleton, Box } from '@mui/material';

import HotelPriceSkeleton from '../SharedHotelCardContent/HotelPriceInfo/HotelPriceSkeleton';
import DateInfoSkeleton from './HotelCardInfoBlocks/DateInfo/Skeleton';
import RegimenInfoSkeleton from '../SharedHotelCardContent/HotelCardInfoBlocks/RegimenInfo/Skeleton';
import TarifaInfoSkeleton from '../SharedHotelCardContent/HotelCardInfoBlocks/TarifaInfo/Skeleton';

const HotelCardSkeleton = ({ idx }) => {
  const nameLineHeight = 16 * 1.5;
  const subNameLineHeight = 14 * 1.5;
  const circularSize = 22;

  return (
    <Grid item xs={12} sm={4} id={`HOTELPAGINATION-SKELETON-${idx}`}>
      <Card
        key={`hotel-skel-${idx}`}
        id="GRIDCARDAIR-SKELETON"
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          flexWrap: { xs: 'wrap', sm: 'nowrap' },
          overflow: { xs: 'hidden', sm: 'visible' },
          borderRadius: '8px 8px 0 0',
          maxWidth: { xs: '300px', sm: '400px' },
          my: { xs: '20px', sm: '15px' },
        }}
      >
        {/* Imagen */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height={144}
          sx={{ borderRadius: '8px 8px 0 0' }}
        />

        <CardContent
          sx={{
            p: '8px 12px',
            '&:last-child': { pb: '16px' },
          }}
        >
          {/* Nombre + Rating */}
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            gap={1}
            sx={{
              mb: 0.5,
              height: '45px',
              flexWrap: { xs: 'wrap', sm: 'nowrap' },
            }}
          >
            <Box sx={{ flex: 1, overflow: 'hidden' }}>
              <Skeleton
                variant="text"
                width="90%"
                height={nameLineHeight}
                sx={{ mb: 1 }}
              />
              <Skeleton variant="text" width="60%" height={subNameLineHeight} />
            </Box>

            <Skeleton
              variant="circular"
              width={circularSize}
              height={circularSize}
            />
          </Grid>

          {/* Precio */}
          <HotelPriceSkeleton />

          {/* Info blocks */}
          <Grid container direction="column" spacing={1}>
            <Grid item xs={12}>
              <DateInfoSkeleton />
            </Grid>

            <Grid item xs={12}>
              <RegimenInfoSkeleton />
            </Grid>

            <Grid item xs={12}>
              <TarifaInfoSkeleton />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default HotelCardSkeleton;
